import { gql } from "lib/apolloClient";
import {
  organizationStaffFragment,
  moduleAccessStaffFragment,
  organizationCoursesFragment,
} from "./EntitySharingFragments";

export const getOrganizationCoursesQuery = gql`
  query getOrganizationCoursesQuery(
    $organizationId: ID!
    $filters: CourseFilterInput
    $shouldFetchRecommendedPhase: Boolean!
    $after: String
    $first: Int
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        courses(
          orderBy: UPDATED_AT
          orderByDirection: ASC
          filters: $filters
          first: $first
          after: $after
        ) {
          edges {
            node {
              ...course
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
        __typename
      }
      __typename
    }
  }
  ${organizationCoursesFragment.course}
`;

export const getMultiNodeCourseQuery = gql`
  query getMultiNodeCourseQuery(
    $ids: [ID!]
    $shouldFetchRecommendedPhase: Boolean!
  ) {
    multiNode(ids: $ids, type: COURSE) {
      ... on Course {
        ...course
      }
    }
  }
  ${organizationCoursesFragment.course}
`;

export const getOrganizationStaffQuery = gql`
  query getOrganizationStaff(
    $organizationId: ID!
    $curriculumProgramIds: [ID!]
    $staffCoursesFilter: [ID!]
    $academicYearIds: [ID!]
    $excludedStaffIds: [ID!]
    $searchText: String
    $after: String
    $first: Int
    $skipTitle: Boolean = false
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        staff(
          after: $after
          first: $first
          filters: {
            curriculumProgramIds: $curriculumProgramIds
            roles: [teacher]
            courses: $staffCoursesFilter
            academicYearIds: $academicYearIds
            searchText: $searchText
            excludedStaffIds: $excludedStaffIds
          }
        ) {
          edges {
            node {
              ...staff
            }
            __typename
          }
          pageInfo {
            hasNextPage
            endCursor
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
  ${organizationStaffFragment.staff}
`;

export const getAdminListQuery = gql`
  query getOrganizationAdmin(
    $organizationId: ID!
    $type: ENTITY_TYPE_ENUM!
    $curriculumProgramId: ID!
    $academicYearIds: [ID!]
    $entityType: [String!]
    $skipTitle: Boolean = false
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        admin: staff(
          filters: { roles: [admin], academicYearIds: $academicYearIds }
        ) {
          edges {
            node {
              ...staff
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    moduleNode: node(id: $curriculumProgramId, type: $type) {
      id
      ... on IbPypCurriculumProgram {
        ...moduleAdmin
      }
      ... on IbDpCurriculumProgram {
        ...moduleAdmin
      }
      ... on IbMypCurriculumProgram {
        ...moduleAdmin
      }
      ... on UBDCurriculumProgram {
        ...moduleAdmin
      }
    }
  }
  ${moduleAccessStaffFragment.admin}
`;

export const getContextEnabledUserQuery = gql`
  query getContextEnabledUser(
    $controlparameterId: ID!
    $context: [ACLContextEntityInput!]
    $academicYearId: ID
    $contextFilters: [RnPRoleContextFilter!]
    $skipTitle: Boolean = false
  ) {
    node(id: $controlparameterId, type: ACL_CONTROL_PARAMETER) {
      id
      ... on ACLPermission {
        id
        enabledUsers(context: $context, academicYearId: $academicYearId) {
          ...staff
          rnpRoleContextDetail(filters: { contextFilters: $contextFilters }) {
            context {
              id
            }
            contextType
            role {
              id
              label
            }
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
  ${organizationStaffFragment.staff}
`;

export const getStaffByIdQuery = gql`
  query getStaffById($ids: [ID!], $skipTitle: Boolean = false) {
    multiNode(ids: $ids, type: STAFF) {
      id
      ... on Staff {
        ...staff
      }
    }
  }
  ${organizationStaffFragment.staff}
`;

export const getRnPLevelsFeedQuery = gql`
  query getRnPLevelsFeed($id: ID!, $rnpViewFilters: RnpViewFilters!) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        rnpView(filters: $rnpViewFilters) {
          id
          ... on RnPRole {
            id
            label
            description
            globalLevel
            assignedUserCount
            isDefaultRole
            isCustomRole
            isSuperAdmin
            globalRole {
              uid
            }
          }
        }
      }
    }
  }
`;

export const getRolesValueQuery = gql`
  query getRolesValue($ids: [ID!]) {
    multiNode(ids: $ids, type: ACL_CONTROL_PARAMETER) {
      ... on ACLPermission {
        id
        uid
        label
        rolesValue(filters: { levels: [COURSE] }) {
          role {
            id
            label
            description
          }
          value
        }
      }
    }
  }
`;
